import { render, staticRenderFns } from "./UserFolder.vue?vue&type=template&id=bc05cf7c&"
import script from "./UserFolder.vue?vue&type=script&lang=js&"
export * from "./UserFolder.vue?vue&type=script&lang=js&"
import style0 from "./UserFolder.vue?vue&type=style&index=0&id=bc05cf7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports